import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";

const duplicateSurvey = async ({ surveyId }) => {
  const token = localStorage.getItem("token");

  if (!surveyId) {
    throw new Error("surveyId is required to duplicate a survey");
  }

  const { data } = await axios.post(
    `${__API_URL__}/api/ecrf/duplicate_new_ecrf/?surveyId=${surveyId}`,
    {}, // no body needed
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return data;
};

const useDuplicateSurveyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: duplicateSurvey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ecrfs_list"] });
      toast.success("Successfully duplicated the eCRF.");
    },
    onError: (error) => {
      console.error("Error duplicating survey:", error);
    },
  });
};

export default useDuplicateSurveyMutation;
